import React from "react";
import { Footer, Methods } from "arv-extends";
import { GridContainer } from "arv-reactcomponents";
import MainBar from "./MainBar";
import DeliveryOffers from "./DeliveryOffers";
import FooterLinks from "./FooterLinks";
import PrivacyPolicy from "./PrivacyPolicy";
import TradeMark from "./TradeMark";

const { getFinalComponent, wrapper } = Footer.default;
const { CheckoutFooter } = Footer;
const { isApp, isIframe } = Methods;

class FooterWC extends wrapper {
  constructor() {
    super();
    this.state = {
      client: false,
    };
  }
  componentDidMount() {
    this.props.FooterStore.getFooterLinkData();
    this.setState({ client: true });
  }
  render() {
    const { footerlinksData } = this.props.FooterStore;
    if (
      isApp ||
      this.hiddenFooter ||
      this.hideFooterClassName ||
      !this.state.client ||
      isIframe
    ) {
      return null;
    } else if (this.staticFooter) {
      return (
        <footer className="nw-footer-wrapper">
          <CheckoutFooter.component />
        </footer>
      );
    }

    return (
      <footer className="wc-footercontainer">
        <GridContainer>
          <MainBar />
          <Footer.FooterDocs.component />
          <DeliveryOffers />
          <FooterLinks data={footerlinksData} />
          <PrivacyPolicy />
          <TradeMark />
        </GridContainer>
      </footer>
    );
  }
}

Footer.default.component = getFinalComponent(FooterWC);
